import type { ShiftAuthUser } from '../../models/auth.types';

export type ShiftCapabilities = {
  isManager: boolean;
  canEditEmployees: boolean;
  canAssignEmployees: boolean;
  canManageSchedule: boolean;
  canCreateEmployees: boolean;
};

export const resolveShiftCapabilities = (user: ShiftAuthUser | null): ShiftCapabilities => {
  const isManager = user?.role === 'manager';
  return {
    isManager,
    canEditEmployees: isManager && user.canEditEmployees,
    canAssignEmployees: isManager && user.canAssignEmployees,
    canManageSchedule: isManager && user.canManageSchedule,
    canCreateEmployees: isManager && user.canCreateEmployees,
  };
};
